"use strict";
/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AreaOutcodeWrapper$ = exports.AreaOutcodeWrapper$outboundSchema = exports.AreaOutcodeWrapper$inboundSchema = void 0;
exports.areaOutcodeWrapperToJSON = areaOutcodeWrapperToJSON;
exports.areaOutcodeWrapperFromJSON = areaOutcodeWrapperFromJSON;
const z = __importStar(require("zod"));
const schemas_js_1 = require("../../../lib/schemas.js");
const areaoutcode_js_1 = require("./areaoutcode.js");
/** @internal */
exports.AreaOutcodeWrapper$inboundSchema = z.object({
    attributes: areaoutcode_js_1.AreaOutcode$inboundSchema,
    id: z.string(),
});
/** @internal */
exports.AreaOutcodeWrapper$outboundSchema = z.object({
    attributes: areaoutcode_js_1.AreaOutcode$outboundSchema,
    id: z.string(),
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var AreaOutcodeWrapper$;
(function (AreaOutcodeWrapper$) {
    /** @deprecated use `AreaOutcodeWrapper$inboundSchema` instead. */
    AreaOutcodeWrapper$.inboundSchema = exports.AreaOutcodeWrapper$inboundSchema;
    /** @deprecated use `AreaOutcodeWrapper$outboundSchema` instead. */
    AreaOutcodeWrapper$.outboundSchema = exports.AreaOutcodeWrapper$outboundSchema;
})(AreaOutcodeWrapper$ || (exports.AreaOutcodeWrapper$ = AreaOutcodeWrapper$ = {}));
function areaOutcodeWrapperToJSON(areaOutcodeWrapper) {
    return JSON.stringify(exports.AreaOutcodeWrapper$outboundSchema.parse(areaOutcodeWrapper));
}
function areaOutcodeWrapperFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.AreaOutcodeWrapper$inboundSchema.parse(JSON.parse(x)), `Failed to parse 'AreaOutcodeWrapper' from JSON`);
}
//# sourceMappingURL=areaoutcodewrapper.js.map